import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRotate90Right12 from './IconRotate90Right12';
import IconRotate90Right16 from './IconRotate90Right16';
import IconRotate90Right20 from './IconRotate90Right20';
import IconRotate90Right24 from './IconRotate90Right24';
import IconRotate90Right32 from './IconRotate90Right32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRotate90Right = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRotate90Right12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRotate90Right16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRotate90Right20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRotate90Right24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRotate90Right32 {...props} />}
        </span>
    );
};
IconRotate90Right.displayName = 'FondueIconRotate90Right';

export default memo(IconRotate90Right);
